<style lang="scss" scoped>
.loading-toast {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  .main {
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    width: 1.8rem;
    height: 1.8rem;
    margin-left: -0.9rem;
    margin-top: -0.9rem;
    background-image: url('~@/images/loading/loading.gif');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 36%;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
  }
}
</style>

<template>
  <div v-show="show" class="loading-toast" @contextmenu.prevent>
    <div class="main"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      duration: 3000
    }
  },
  methods: {
    delayHide(cb) {
      setTimeout(() => {
        this.show = false
        cb && cb()
      }, this.duration)
    }
  }
}
</script>
